// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"389":"1aa28d11","889":"12f6524e"}[chunkId] + ".css";
};